import { API_ENDPOINT } from './config';

export const urlsYellowBooks = {
  yellowBooks: `${API_ENDPOINT}/yellow-books`,
  yellowBookDetail: (id) => `${API_ENDPOINT}/yellow-books/${id}`,
  yellowBookPdf: (id, save = false) =>
    `${API_ENDPOINT}/yellow-books/${id}/pdf${save ? '?save=true' : ''}`,
  yellowBookSections: (yellowBookId) =>
    `${API_ENDPOINT}/yellow-books/${yellowBookId}/sections`,
  yellowBookSectionDetail: (yellowBookId, sectionId) =>
    `${API_ENDPOINT}/yellow-books/${yellowBookId}/sections/${sectionId}`,
  yellowBookSectionsTree: (yellowBookId) =>
    `${API_ENDPOINT}/yellow-books/${yellowBookId}/sections?tree=true`,
  yellowBookDataItems: `${API_ENDPOINT}/yellow-books/data-items`,
};

export const routesYellowBooks = {
  // CMS
  cmsYellowBooks: '/cms/yellow-books',
  cmsYellowBooksArchived: '/cms/yellow-books/archived',
  cmsYellowBooksEdit: '/cms/yellow-books/edit',
  cmsYellowBooksCreate: '/cms/yellow-books/create',
  cmsYellowBooksSections: (yellowBookId) =>
    `/cms/yellow-books/${yellowBookId}/sections`,
  cmsYellowBookSectionsEdit: (yellowBookId, sectionId) =>
    `/cms/yellow-books/${yellowBookId}/sections/edit/${sectionId}`,
  cmsYellowBookSectionsCreate: (yellowBookId) =>
    `/cms/yellow-books/${yellowBookId}/sections/create`,
  cmsYellowBookSectionsChild: (yellowBookId, sectionId) =>
    `/cms/yellow-books/${yellowBookId}/sections/${sectionId}/create`,
  cmsYellowBookSectionsCopy: (yellowBookId, sectionId) =>
    `/cms/yellow-books/${yellowBookId}/sections/${sectionId}/copy`,
  cmsYellowBookSectionsOrder: (yellowBookId) =>
    `/cms/yellow-books/${yellowBookId}/sections/order`,
};
